<template>
  <div class="row">
    <div class="col-6 px-2">
      <label for="briefCase" class="d-block text-center">
        <b-img src="@/assets/images/bottle-box/brief-case.png" fluid alt="valigetta"></b-img>
        <b-form-radio id="briefCase" v-model="vModel" name="boxType" :value="BOTTLE_BOX_TYPES.BRIEF_CASE"></b-form-radio>
        <small>{{ $t('props.boxTypes.briefCase') }}</small>
      </label>
    </div>
    <div class="col-6 px-2">
      <label for="slipCase" class="d-block text-center">
        <b-img src="@/assets/images/bottle-box/slip-case.png" fluid alt="cofanetto"></b-img>
        <b-form-radio id="slipCase" v-model="vModel" name="boxType" :value="BOTTLE_BOX_TYPES.SLIP_CASE"></b-form-radio>
        <small>{{ $t('props.boxTypes.slipCase') }}</small>
      </label>
    </div>
  </div>
</template>
<script>
import { InputField } from '../Input.mixin'
import { BOTTLE_BOX_TYPES } from '../../../utils/products.enums'

export default {
  name: 'InputBottleBoxType',
  extends: InputField,
  data () {
    return {
      BOTTLE_BOX_TYPES
    }
  }
}
</script>
